import dynamic from 'next/dynamic';
import styles from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import ScrollMagicFn from '@/utils/ScrollMagic';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export const zhCnOrderLink = 'https://ecoflow.feishu.cn/share/base/form/shrcnHslMKYvbJeBzG8Qx0WaOlb?from=navigation';
export default function Powerocean() {
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    if (typeof window !== 'undefined' && !window.ScrollMagic) {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(window.ScrollMagic, TweenMax, TimelineMax);
    }
    return (
        <div className={`powerocean ${styles['powerocean']}`}>
            <IndexDynamic />
        </div>
    );
}
